import client from '../../providers/fetchClient'

export const createEletronicSignature = data => client.post('/v3/electronic-signatures', data)

export const getEletronicSignatures = params => client.get('/v3/electronic-signatures', { params })
